import { Component } from "react";

export default class ErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        padding: 80,
                        textAlign: "center",
                        fontFamily: "sans-serif",
                        background: "#FFFDF5",
                        minHeight: "100vh",
                    }}
                >
                    <h1 style={{ fontSize: 28 }}>Something buzzed loose</h1>
                    <p style={{ color: "#524A42" }}>Please refresh the page.</p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: 16,
                            padding: "10px 26px",
                            borderRadius: 9999,
                            background: "#F59E0B",
                            border: "none",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Refresh
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
